module.exports = __webpack_public_path__ + "img/search-outline.e41929e1.svg";